import Box, { type BoxProps } from '@mui/material/Box';
import { ErrorComponent } from '@openx/components-core/lib/Error/Error';
import { NotFoundImage } from '@openx/components-core/lib/Error/pictures/NotFound';
import { Loader } from '@openx/components-core/lib/Loader/Loader';
import { type JSX, useCallback } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router';

const CenterContent = (props: BoxProps) => (
  <Box
    sx={[
      { alignItems: 'center', display: 'flex', height: '100vh', justifyContent: 'center' },
      ...(Array.isArray(props.sx) ? props.sx : [props.sx]),
    ]}
    {...props}
  />
);

export const PageNotFound = (): JSX.Element => {
  const navigate = useNavigate();

  const location = useLocation();

  const [searchParams, _setSearchParams] = useSearchParams();

  const fallback = searchParams.get('fallback');

  const redirectHome = useCallback(() => {
    navigate('/');
  }, [navigate]);

  const redirectFallback = () => {
    searchParams.delete('fallback');
    window.location.replace(
      new URL(`${location.pathname}${searchParams.size ? `?${searchParams.toString()}` : ''}`, window.origin)
    );
  };
  const host = window.location.host;
  if (fallback) {
    redirectFallback();
    return (
      <CenterContent>
        <Loader />
      </CenterContent>
    );
  }
  if (!host.includes('localhost')) {
    if (location.pathname.includes('/docs')) {
      // React Router Should Never handle Docs as reload is required for nginx routing
      window.location.replace('/docs/openxselect/oxs-main/index.html');
      return (
        <CenterContent>
          <Loader />
        </CenterContent>
      );
    }
  }

  return (
    <ErrorComponent
      title="Page Not Found"
      titlePrefix="OpenX"
      subtitle="We've looked everywhere and we just can't find that page in our universe."
      actions={[
        {
          children: 'Take me home please',
          color: 'secondary',
          'data-test': 'return-home',
          onClick: redirectHome,
          variant: 'contained',
        },
      ]}
      PictureComponent={NotFoundImage}
      data-test="page-not-found"
      //devDebug={'Route: ' + location.pathname}
    />
  );
};
